import { RiDoubleQuotesL, RiDoubleQuotesR } from "react-icons/ri";
import { FcBusinessman } from "react-icons/fc";

const testimonials = [
  {
    id: 1,
    name: "Casa Da Vida",
    role: "Navsari",
    image: <FcBusinessman />,
    quote:
      "Thrilled with H-Line's facade work! They transformed the exterior into a perfect blend of aesthetics and functionality.",
  },
  {
    id: 2,
    name: "Pyramid Group",
    role: "Surat",
    image: <FcBusinessman />,
    quote:
      "Impressed by the quality! H-Line's window and door solutions combine security with a sleek, modern design.",
  },
  {
    id: 3,
    name: "KP Solar",
    role: "Bharuch",
    image: <FcBusinessman />,
    quote:
      "H-Line's expertise in aluminum solutions — windows, doors, and facades — set a new standard by delivering both durability and modern appeal.",
  },
  {
    id: 4,
    name: "River Vista",
    role: "Ahmedabad",
    image: <FcBusinessman />,
    quote:
      "Professional and timely service! H-Line's precision in execution exceeded expectations for our office complex.",
  },
  {
    id: 5,
    name: "Tapi Darshan",
    role: "Surat",
    image: <FcBusinessman />,
    quote:
      "They deliver excellence! The facade detailing and finishing by H-Line have given our property a premium identity.",
  },
  {
    id: 6,
    name: "Blue Star",
    role: "Surat",
    image: <FcBusinessman />,
    quote:
      "Their craftsmanship is top-notch! The windows and curtain walls look elegant and durable at the same time.",
  },
];

export default function TestimonialsMarquee() {
  return (
    <section
      id="reviews"
      className="container relative py-10 bg-transparent scroll-mt-24 overflow-hidden"
    >
      <p className="text-[11px] md:text-xs tracking-[0.28em] uppercase text-white/70">
        What Our Clients Say
      </p>
      <h2 className="mt-3 text-2xl sm:text-4xl md:text-5xl font-extrabold text-white leading-tight">
        Windows, doors & architectural systems.
      </h2>
      <p className="mt-4 text-white/80 md:text-lg leading-relaxed max-w-3xl mb-10">
        Real words from real clients — across homes, offices and industries.
      </p>

      <div className="relative w-full overflow-hidden">
        <div className="flex animate-marquee space-x-8">
          {[...testimonials, ...testimonials].map((item) => (
            <div
              key={item.id + Math.random()}
              className="min-w-[300px] sm:min-w-[350px] md:min-w-[400px] 
                         rounded-[30px] border border-white/10 p-6 sm:p-8 
                         text-white/90 shadow-[inset_0_1px_2px_rgba(255,255,255,0.15),0_25px_60px_rgba(0,0,0,0.7)]
                         backdrop-blur-[60px] backdrop-saturate-[180%] 
                         bg-[rgba(16,16,16,0.55)] hover:bg-[rgba(30,60,150,0.35)] transition-colors duration-500"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="h-12 w-12 rounded-md bg-white/10 flex items-center justify-center border border-white/20">
                  <div className="text-[32px]">{item.image}</div>
                </div>
                <div
                  className="px-4 py-2 rounded-lg border border-white/10 
                    bg-[rgba(30,60,150,0.35)] backdrop-blur-[20px] backdrop-saturate-[180%]
                    shadow-[inset_0_1px_2px_rgba(255,255,255,0.15),0_4px_10px_rgba(0,0,0,0.6)]"
                >
                  <p className="font-semibold text-white text-base leading-tight">
                    {item.name}
                  </p>
                  <p className="text-[11px] text-blue-100/90">{item.role}</p>
                </div>
              </div>

              <blockquote className="text-white/90 text-base sm:text-lg leading-relaxed">
                <span className="inline-block text-white/60 text-2xl mr-1 align-top">
                  <RiDoubleQuotesL />
                </span>
                {item.quote}
                <span className="inline-block text-white/60 text-2xl ml-1 align-bottom">
                  <RiDoubleQuotesR />
                </span>
              </blockquote>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-marquee {
          animation: marquee 25s linear infinite;
          width: calc(200%);
        }
      `}</style>
    </section>
  );
}
